import * as React from 'react';

export interface IListTableColumnProps<T = any> {
  column: string;
  source?: string | string[];
  excelSource?: string;
  label?: string;
  sortable?: boolean;
  value?: any;
  showDefault?: boolean;
  ignoreOnExcel?: boolean;
  tdProps?: React.DetailedHTMLProps<
    React.TdHTMLAttributes<HTMLTableDataCellElement>,
    HTMLTableDataCellElement
  >;
  settingsGroup?: string;
  formatContent?: (value?: any) => React.ReactNode | undefined;
  nullContent?: React.ReactNode;
  onClick?: (rowData: T, index: number, value: any) => void;
  sortKey?: string;
  fixed?: boolean;
  fixedPosition?: 'start' | 'end';
  anotherValue?: string;
  anotherSource?: string;
  cssClass?: string;
  diableClick?: boolean;
  addDesign?: boolean;
  additionalValue?: string;
  dependentValue?: any;
  dependentSource?: string | string[];
}

const ListTableColumn: React.FunctionComponent<IListTableColumnProps> = (
  props
) => {
  let value: any = props.value;
  if (props.value === undefined || props.value === null) {
    if (props.nullContent) {
      value = props.nullContent;
    }
  } else {
    if (props.formatContent) {
      value = props.formatContent(props.value);
    }
  }
  if (props.additionalValue && props.dependentValue) {
    return (
      <>
        {value}{' '}
        <span
          className={`vstatus-${props.additionalValue
            ?.toLowerCase()
            ?.split(' ')
            .join('')} ${props.cssClass || ''}`} // add css class for corresponding additional value in listing.scss
        >
          {' '}
          {props.additionalValue}
        </span>
      </>
    );
  }
  if (props.addDesign) {
    // add css class for particular value names in listing.scss if a special design needed for particular value
    return (
      <>
        {' '}
        <span
          className={`vstatus-${value?.toLowerCase()?.split(' ').join('')} ${props.cssClass || ''}`}
        >
          {value}
        </span>
      </>
    );
  }

  return <>{value} </>;
};

export default ListTableColumn;
